<template>
  <form-widget-result
    :title="$t('widget.form.success_title')"
    :content="$t('widget.form.success_message')"
    :action-label="$t('button.close')"
    @click="$emit('close')"
  >
    <template #result-icon>
      <dp-icon-check-filled :size="64" color="secondary" />
    </template>
  </form-widget-result>
</template>

<script>
import { defineComponent } from 'vue';

import { DpIconCheckFilled } from '@dp-ui-kit/icons';

import FormWidgetResult from './FormWidgetResult.vue';

export default defineComponent({
  name: 'FormWidgetSuccess',

  components: {
    DpIconCheckFilled,
    FormWidgetResult,
  },
  emits: ['close'],
});
</script>
